module.exports = __webpack_public_path__ + "static/media/nexus.f2955f60.svg";